import { call, select } from 'redux-saga/effects';
import { RootState } from '../../../../core/redux/store';
import { HistoryActionType, SheetsHistory } from '../../../types';
import _ from 'lodash';
import {
  CommandHistory,
  CommandHistoryPast,
  RawCommandsHistory,
  SheetManagementSet,
} from '../../../types/sheet/draft';
import { startUpdateSheetsState } from '../root/root';
import { executeSheetsCommand } from '../../../utils/commands/execute/executeSheetsCommand';
import { generateSheetsDataSet } from '../root/rootHelpers';
import { showErrorToast } from '../../../../core/utils/view/toast';
import sessionStorageSingleton from '../../../../core/configs/sessionStorageSingleton';

export function* startUndoSheets() {
  const history: SheetsHistory = yield select(
    (state: RootState) => state.sheetsManager.history2
  );
  const latestHistory = _.last(history.past);
  if (latestHistory) {
    yield call(startApplyHistory, latestHistory, HistoryActionType.Undo);
  }
}

export function* startRedoSheets() {
  const history: SheetsHistory = yield select(
    (state: RootState) => state.sheetsManager.history2
  );
  const latestHistory = history.future[0];
  if (latestHistory) {
    yield call(startApplyHistory, latestHistory, HistoryActionType.Redo);
  }
}

function* startApplyHistory(
  history: Partial<CommandHistoryPast>,
  historyAction: HistoryActionType
) {
  console.log('history === > ', history, historyAction);

  const set: SheetManagementSet = yield generateSheetsDataSet();

  try {
    if (history.creationCommands) {
      for (const command of history.creationCommands) {
        yield executeSheetsCommand(set, command);
      }
    }

    if (history.groupCommands) {
      console.log('history.groupCommands', history.groupCommands);

      for (const key of history.groupCommands.keys()) {
        console.log('key', key, history.groupCommands.get(key));
        const commands = history.groupCommands.get(key);
        console.log('group === commands', commands);
        if (commands) {
          for (const command of commands) {
            yield executeSheetsCommand(set, command);
          }
        }
      }
    }

    if (history.sheetCommands) {
      for (const key of history.sheetCommands.keys()) {
        const commands = history.sheetCommands.get(key);
        if (commands) {
          for (const command of commands) {
            yield executeSheetsCommand(set, command);
          }
        }
      }
    }

    if (history.deletionCommands) {
      for (let command of history.deletionCommands) {
        yield executeSheetsCommand(set, command);
      }
    }

    yield startUpdateSheetsState(set, historyAction);
  } catch (err) {
    sessionStorageSingleton.release();
    console.log(err);
    if (err instanceof Error && err.message) {
      showErrorToast(err.message);
    }
  }
}
